/** @format */

import React from "react";
import cn from "classnames";
import moment from "moment/moment";
import { isMobile } from "react-device-detect";
import style from "./style.module.scss";
import CustomDatePicker from "../../shared/date-picker/Date";
import CustomDateTime from "../../shared/date-picker/Time";
import ClockIcon from "../../shared/icons/ClockIcon";
import CalendarIcon from "../../shared/icons/CalendarIcon";
import ArrowDownIcon from "../../shared/icons/ArrowDownIcon";
import {t} from "i18next";

const OrdersDatePicker = ({
  date,
  timeStart,
  timeEnd,
  isEditable = false,
  isSender = false,
  minDate,
  setDate,
  setTimeStart,
  setTimeEnd,
  detect,
  labelText = "",
  labelTimeStart = "",
  labelTimeEnd = "",
  errorDate = "",
  errorTimeStart = "",
  errortimeEnd = "",
  placeholderText = "00.00.00",
}) => {
  const prefixTimeType = isSender ? t("common.datetime.loading") : t("common.datetime.unloading")
  const setPlaceholderTime = (time) => {
    return time ? moment(time).format("HH:mm") : "__:__";
  };
  const filterPassedTime = (time) => {
    const currentDate = timeStart || new Date(new Date().setHours(0));
    const selectedDate = new Date(time);
    return currentDate?.getTime() < selectedDate?.getTime();
  };
  const setChangeStart = (date, ignoreSave = false) => {
    setTimeStart(date);
    if (detect && !ignoreSave) detect();
  };

  const onChangeDate = (date) => {
    const dateWithZeroTime = new Date(date);
    dateWithZeroTime.setHours(0);
    dateWithZeroTime.setMinutes(0);
    dateWithZeroTime.setSeconds(0);

    setDate(dateWithZeroTime);
    if (!timeStart) {
      setChangeStart(new Date(date.setHours(9)), true);
    }
    if (!timeEnd) {
      setTimeEnd(new Date(date.setHours(18)));
    }
    if (detect) detect();
  };

  const ContentItemEditable = (type) => {
    let input = "";
    if (type === "date") {
      input = (
        <CustomDatePicker
          selected={date}
          dateFormat="dd.MM.yyyy"
          placeholderText={placeholderText}
          monthsShown={1}
          minDate={minDate}
          onChange={onChangeDate}
          withPortal={isMobile}
        />
      );
    } else if (type === "time-start") {
      input = (
        <CustomDateTime
          selected={timeStart}
          timeCaption={t("common.datetime.timePrefix") + `${prefixTimeType}` + t("common.datetime.from") + `${setPlaceholderTime(timeEnd)}`}
          onChange={setChangeStart}
        />
      );
    } else if (type === "time-before") {
      input = (
        <CustomDateTime
          selected={timeEnd}
          filterTime={filterPassedTime}
          timeCaption={t("common.datetime.timePrefix") + `${prefixTimeType}` + t("common.datetime.to") + `${setPlaceholderTime(timeEnd)}`}
          onChange={setTimeEnd}
        />
      );
    }

    return input;
  };

  return (
    <>
      <div>
        <div
          className={cn("d-flex align-items-center justify-content-between", {
            [style.editable]: isEditable,
            [style.errorState]: errorDate,
          })}
        >
          <div
            className={cn(style.labelInp, { [style.labelError]: errorDate })}
          >
            {labelText}
          </div>
          {isEditable ? ContentItemEditable("date") : ContentItem("date", date)}
          <CalendarIcon />
        </div>
        {errorDate && <div className={style.errorText}>{errorDate}</div>}
      </div>
      <div className={cn(style.wrapper_time)}>
        <div>
          <div
            className={cn("d-flex align-items-center", {
              [style.editable]: isEditable,
              [style.errorState]: errorTimeStart,
            })}
          >
            <div
              className={cn(style.labelInp, {
                [style.labelError]: errorTimeStart,
              })}
            >
              {labelTimeStart}
            </div>
            {isEditable ? ContentItemEditable("time-start", t("common.datetime.from") ) : ContentItem("time", timeStart, t("common.datetime.from") )}
            <ArrowDownIcon stroke="#6D7885" width="20px" height="20px" />
          </div>
          {errorTimeStart && (
            <div className={style.errorText}>{errorTimeStart}</div>
          )}
        </div>

        <div>
          <div
            className={cn("d-flex align-items-center", {
              [style.editable]: isEditable,
              [style.errorState]: errortimeEnd,
            })}
          >
            <div
              className={cn(style.labelInp, {
                [style.labelError]: errortimeEnd,
              })}
            >
              {labelTimeEnd}
            </div>
            {isEditable ? ContentItemEditable("time-before", t("common.datetime.to")) : ContentItem("time", timeEnd, t("common.datetime.to"))}
            <ArrowDownIcon stroke="#6D7885" width="20px" height="20px" />
          </div>
          {errortimeEnd && (
            <div className={style.errorText}>{errortimeEnd}</div>
          )}
        </div>
      </div>
    </>
  );
};
const ContentItem = (type = "", value, prefixStart = "") => {
  let text = "";

  if (type === "date") {
    text = moment.utc(value).format("DD.MM.YYYY");
  } else if (type === "time") {
    text = moment.utc(value).format("HH:mm");
  }

  return (
    <span className="ms-1">
      {prefixStart}
      {text}
    </span>
  );
};

export default OrdersDatePicker;
